export default "__VITE_ASSET__6AeHbSor__"